"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./NavList.style"));
const NavItem = ({ href, isNavTitle, isActive, children, subNav, onClick, }) => {
    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };
    return (react_1.default.createElement(S.ListItem, { "$isActive": isActive },
        isNavTitle ? (href ? (react_1.default.createElement(S.SubNavTitleLink, { href: href, onClick: handleClick }, children)) : (react_1.default.createElement(S.SubNavTitle, null, children))) : href ? (react_1.default.createElement(S.NavItemLink, { href: href, onClick: handleClick }, children)) : (react_1.default.createElement(S.NavItemText, null, children)),
        subNav && (react_1.default.createElement(S.SubNav, null, subNav.map((item) => (react_1.default.createElement(NavItem, { key: item.href, href: item.href, isActive: window.location.pathname === item.href, onClick: item.onClick }, item.label)))))));
};
exports.default = NavItem;
